// extracted by mini-css-extract-plugin
export default {"container":"Payments_container__b4La0","wrapper":"Payments_wrapper__hOnzI","paragraph":"Payments_paragraph__rDXsj","icon":"Payments_icon__bykOc"};